export default __webpack_public_path__ + "static/media/ptt.72046255.jfif";